
import ajax from "./ajax";

export const listByPage = params => ajax(`/joinApplication/listByPage`, params,'POST');
export const deleteMutil = params => ajax(`/joinApplication/deleteMutil`, params,'POST');

